<template>
    <section id="monitor-multiple-signs">
        <div v-for="(item, index) in data" 
            :key="index" 
            class="signs-table"
        >
            <div class="signs-table__key">
                <b>{{ item['idx'] }}</b>
            </div>
            <div class="signs-table__value">
                <span v-for="(sign, sign_index) in item['sign_icons']" 
                    :key="sign_index"
                    class="icon__box " 
                > 
                    <span v-if="sign !== '-'" 
                        v-html="sign" 
                    />
                    <span v-else>{{ sign }}</span>
                </span>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        name: 'MonitorMultipleSigns',
        
        props: {
            data: {
                type: Array,
                required: true
            },

            icon_path: {
                type: String,
                default() {
                    return'/static/images/product/monitor_table_icon/'
                }
            },

            icons: {
                type: Array,
                default: () => [
                    {'file_name': 'rain3', 'file_text': '雨量警戒'},
                    {'file_name': 'wind', 'file_text': '大風警戒'},
                    {'file_name': 'tmax', 'file_text': '高溫警示'},
                    {'file_name': 'tmin', 'file_text': '低溫警示'},
                    {'file_name': 'swell', 'file_text': '長浪警戒'},
                    {'file_name': 'waveheight', 'file_text': '浪高警戒'},
                    {'file_name': 'seatmax', 'file_text': '高海溫警示'},
                    {'file_name': 'seatmin', 'file_text': '低海溫警示'},
                ]
            }
        },
    }
</script>

<style lang="scss">
    @import '../../../../css/mixin';
    @import '../../../../css/monitor/sign';

    #monitor-multiple-signs {
        margin: 0.5rem 1rem;
        font-size:1.1rem;
        display: grid;
        grid-template-columns: repeat(6, 1fr);

        @include laptop {
            grid-template-columns: repeat(4, 1fr);
        }

        @include mobile {
            grid-template-columns: repeat(2, 1fr);
        }

        .signs-table {
            display: flex;
            flex-direction: column;
            margin: 0 1.5px;
            box-sizing: border-box;

            &__key { 
                background-color: #edf3ff;
                text-align: center;
                font-weight: normal;
                line-height: 1.5;
                letter-spacing: 0.8px;
                color: #151927
            }

            &__value { 
                display: grid;
                grid-template-columns: repeat(4, 1fr);
                text-align: center;
            }
        }

        .icon {
            &__box {
                min-height: 30px;
            }

            &__image {
                max-width: 30px;
                max-height: 30px;
                width: 2vw;
                vertical-align: middle;
            }
        }
    }
</style>